const columns = [
  { name: "Nome do Organização", value: "organization", filter: false },
  { name: "Subdominio", value: "subdomain", filter: false },
];

export { columns };
